import axios from "axios";

export const resolve = (sessionId, success, failure) => {
    const url = "/api/v1/stripe/resolve?sessionId=" + sessionId;

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const fulfill = (sessionId, user, success, failure) => {
    const url = "/api/v1/stripe/fulfill";

    axios.post(url, {
        sessionId: sessionId,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        password: user.password,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};
